
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_phaseBC",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.phaseBC')
        },
        value() {
            return this.unitLmsgSensors?.phaseBC?.value ?
                (this.unitLmsgSensors?.phaseBC?.value + ' ' + this.unitLmsgSensors?.phaseBC?.units) :
                ''//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'sensors__battary_voltage' : false
        }
    },
}
</script>

<style scoped>

</style>